import React, { useEffect, useState } from 'react';
import { apiService, CalibrationProfile } from '../../services/apiService';

interface CalibrationProfilePanelProps {
  rubricCriteria: Array<{ name: string; maxScore: number }>;
}

export const CalibrationProfilePanel: React.FC<CalibrationProfilePanelProps> = ({ rubricCriteria }) => {
  const [rubricKey, setRubricKey] = useState<string>('');
  const [profile, setProfile] = useState<CalibrationProfile | null>(null);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const res = await apiService.getCalibrationProfile(rubricCriteria);
    setRubricKey(res.rubricKey || '');
    setProfile(res.profile);
    setDraft(res.profile?.profileText || '');
    setLoading(false);
  };

  useEffect(() => {
    if (rubricCriteria && rubricCriteria.length > 0) { load(); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async () => {
    if (!rubricKey) return;
    await apiService.updateCalibrationProfile(rubricKey, draft);
    setEditing(false);
    load();
  };

  const clear = async () => {
    if (!rubricKey) return;
    await apiService.clearCalibrationProfile(rubricKey);
    load();
  };

  if (loading) return null;
  if (!profile && !editing) return null; // nothing learned yet

  return (
    <div className="card-playful p-4 mb-6">
      <h3 className="font-medium text-gray-900 mb-2">What MarkerMate has learned about your marking</h3>
      {editing ? (
        <>
          <textarea
            value={draft}
            onChange={e => setDraft(e.target.value)}
            className="w-full text-sm border border-gray-300 rounded p-2 mb-2"
            rows={6}
          />
          <div className="space-x-2">
            <button onClick={save} className="btn-primary text-sm">Save</button>
            <button onClick={() => { setEditing(false); setDraft(profile?.profileText || ''); }} className="btn-secondary text-sm">Cancel</button>
          </div>
        </>
      ) : (
        <>
          <pre className="text-sm text-gray-700 whitespace-pre-wrap font-sans mb-2">{profile?.profileText}</pre>
          <p className="text-xs text-gray-500 mb-2">
            Built from {profile?.builtFromCount} pieces of your feedback{profile?.editedByTeacher ? ' (edited by you)' : ''}.
          </p>
          <div className="space-x-2">
            <button onClick={() => setEditing(true)} className="btn-secondary text-sm">Edit</button>
            <button onClick={clear} className="btn-secondary text-sm">Clear</button>
          </div>
        </>
      )}
    </div>
  );
};
